import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/foundation/adaptersList';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const params = new URLSearchParams();
    if (action.payload?.family)     params.set('family',     action.payload.family);
    if (action.payload?.slug)       params.set('slug',       action.payload.slug);
    if (action.payload?.task)       params.set('task',       action.payload.task);
    if (action.payload?.owner)      params.set('owner',      action.payload.owner);
    if (action.payload?.visibility) params.set('visibility', action.payload.visibility);
    const url = `${config.API_URL}/models/foundation/adapters${params.toString() ? '?' + params.toString() : ''}`;
    const response = yield call(axios.get, url, { headers: getLocalUser() });
    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
